import React, { FC } from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import { useTheme } from "@material-ui/core";

const LogoutDoorIcon: FC<SvgIconProps> = props => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16">
      <defs>
        <polygon
          id="path-1"
          points="0.000118518519 5.42372881e-05 15.7620741 5.42372881e-05 15.7620741 15.864678 0.000118518519 15.864678"
        />
      </defs>
      <g id="Screen" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Logout_16px">
          <mask id="mask-2" fill="white">
            <use href="#path-1" />
          </mask>
          <g id="Clip-2" />
          <path
            d="M7.35300741,11.2526644 L6.52663704,10.4751729 L8.77285926,8.47463051 L0.000118518519,8.47490169 L0.000118518519,7.39015593 L8.77285926,7.38988475 L6.52663704,5.38961356 L7.35300741,4.61212203 L11.0813037,7.93225763 L7.35300741,11.2526644 Z M5.69404444,15.8647322 C4.92574815,15.8647322 4.30085926,15.2925288 4.30085926,14.5893424 L4.30085926,10.5169356 L5.48604444,10.5169356 L5.48604444,14.5893424 C5.48604444,14.6942915 5.57937778,14.7799864 5.69404444,14.7799864 L14.3687111,14.7797153 L14.3690074,14.7797153 C14.4442667,14.7797153 14.4934519,14.7447322 14.5159704,14.724122 C14.5387852,14.7032407 14.5770074,14.6582237 14.5770074,14.5893424 L14.5770074,1.27544407 C14.5770074,1.17022373 14.4833778,1.0848 14.3684148,1.0848 L5.69404444,1.08507119 C5.57937778,1.08507119 5.48604444,1.17049492 5.48604444,1.27544407 L5.48604444,5.38690169 L4.30085926,5.38690169 L4.30085926,1.27544407 C4.30085926,0.572257627 4.92574815,0.000325423729 5.69404444,0.000325423729 L14.3687111,5.42372881e-05 C15.1373037,0.000596610169 15.7621926,0.572528814 15.7621926,1.27544407 L15.7621926,14.5893424 C15.7621926,14.9302237 15.6173037,15.2502237 15.3538963,15.4910373 C15.0910815,15.7318508 14.7414519,15.864461 14.3693037,15.864461 L14.3684148,15.864461 L5.69404444,15.8647322 Z"
            id="Fill-1"
            fill={theme.palette.primary.main}
            mask="url(#mask-2)"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default LogoutDoorIcon;
